<template>
  <div class="container">
    <div class="container-content">
      <div class="content-title">心康医生知识库</div>
      <div class="content-item">
        <div class="content-left">
          <div class="left-title">
            <div class="left-title-text">全部（{{groupList.length}}）</div>
            <div class="left-title-text" @click="newly">+ 新建</div>
          </div>
          <div
            class="left-item"
            :class="{ active: activeItem === item }"
            v-for="item in groupList"
            :key="item.id"
            @click="activeItem = item"
          >
            <span class="item-text">{{ item.name }}</span>
            <el-popover width="30" trigger="hover">
              <div class="content">
                <div @click="click_edit(item)">修改</div>
                <div @click="click_delete(item)">删除</div>
              </div>
              <template #reference>
                <el-icon color="#c7c7c7" class="item-slh"
                  ><MoreFilled
                /></el-icon>
              </template>
            </el-popover>
          </div>
        </div>
        <div class="content-right">
          <div class="query">
            <MyForm
              class="search-form"
              :formOptions="queryForm"
              :inline="true"
            ></MyForm>
            <div class="query-text">{{ activeItem ? `当前知识库共包含${ total }个问题` : "请选择一个知识库" }}</div>
          </div>
          <div class="table">
            <MyTable :table-options="tableOptions" border max-height="60vh">
              <template #handler="{ row }">
                <!-- <el-button
                  style="color: #6fcaf7"
                  icon="View"
                  link
                  @click="click_Row_look(row)"
                  >查看</el-button
                > -->
                <el-button
                  style="color: #6fcaf7"
                  icon="Edit"
                  link
                  @click="click_Row_edit(row)"
                  >修改</el-button
                >
                <el-button
                  style="color: #6fcaf7"
                  icon="Delete"
                  link
                  @click="click_Row_delete(row)"
                  >删除</el-button
                >
              </template>
            </MyTable>
          </div>
        </div>
      </div>
      <MyPagination :params="listParams" :total="total" @get-list="getList" ref="pagination" />
    </div>
    <!-- 新建模态框 -->
    <Dialog
      width="30%"
      v-model="addVisible"
      :title="title"
      top="5vh"
      @closed="name = ''"
    >
      <el-form>
        <el-form-item label="分组名称:">
          <el-input v-model="name"></el-input>
        </el-form-item>
      </el-form>
      <div class="submit-buttons">
        <el-button plain @click="addVisible = false">取消</el-button>
        <MyButton @click="click_confirm">确定</MyButton>
      </div>
    </Dialog>
    <!-- 添加问题 -->
    <el-drawer
      v-model="drawerVisible"
      :with-header="false"
      size="400"
      @closed="handleClosedDrawer"
    >
      <div class="title">
        <el-icon @click="drawerVisible = false"><Close /></el-icon> <span style="margin-left: 4px;">{{ titleDrawer }}</span>
      </div>
      <div class="content">
        <el-form label-width="auto">
          <el-form-item label="选择分组:">
            <el-select
              v-model="addParams.KnowledgeBaseGroupId"
              :disabled="!!addParams.id"
            >
              <el-option
                v-for="item in groupList"
                :value="item.id"
                :label="item.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="标准问题:">
            <el-input v-model="addParams.topic"></el-input>
          </el-form-item>
          <el-form-item label="关键字:">
            <DynamicTag v-model="addParams.key" addText="添加关键字" />
          </el-form-item>
        </el-form>
        <div class="answer">
          <div class="box">
            <div class="title">
              <span>回答</span>
            </div>
            <div class="answer-content">
              <span>回答内容</span>
              <el-input
                v-model="addParams.answerContent"
                type="textarea"
                :rows="5"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="submit-buttons">
        <el-button plain @click="drawerVisible = false">取消</el-button>
        <MyButton @click="click_save">保存</MyButton>
      </div>
    </el-drawer>
  </div>
</template>

<script setup>
import { ref, reactive, watch } from "vue";
import MyTable from "@/components/Global/MyTable.vue";
import MyPagination from "@/components/Global/MyPagination.vue";
import Dialog from "@/components/Common/Dialog.vue";
import DynamicTag from "@/components/Common/DynamicTag.vue";
import { dayjs, ElMessage, ElMessageBox } from "element-plus";
import knowledgeGroupApi from "@/api/knowledgeGroup.js";

//搜索
const queryForm = reactive({
  itemList: [
    {
      type: "Input",
      label: "关键词:",
      prop: "Key",
    },
    {
      type: "Button",
      value: "查询",
      attrs: {
        icon: "Search",
      },
      events: {
        click(formData) {
          Object.assign(listParams, formData);
        },
      },
    },
    {
      type: "Button",
      value: "添加",
      attrs: {
        icon: "Plus",
        style: {
          marginRight: "70px",
        },
      },
      events: {
        click(formData) {
          drawerVisible.value = true;
          titleDrawer.value = '添加问题'
        },
      },
    },
  ],
});

// 分页
const pagination = ref();
const total = ref(0);
const tableOptions = reactive({
  colList: [
    // { type: "index", label: "序号", width: 60 },
    { label: "标准问题", prop: "topic", width: 500 },
    { label: "关键词", prop: "key" },
    { label: "更新时间", prop: "creationTime" },
    { type: "slot", slot_name: "handler", label: "操作", width: 300 },
  ],
  tableData: [],
});
const listParams = reactive({
  KnowledgeBaseGroupId: "",
  Key: "",
});
const activeItem = ref(null);
watch(
  () => activeItem.value,
  (val) => {
    if (val) {
      addParams.value.KnowledgeBaseGroupId = val.id;
      listParams.KnowledgeBaseGroupId = val.id;
    } else {
      addParams.value.KnowledgeBaseGroupId = "";
      listParams.KnowledgeBaseGroupId = "";
    }
  }
);
const getList = async (params = pagination.value.getList_params) => {
  params = { ...params,...listParams };
  if(!params.KnowledgeBaseGroupId){
    return
  }
  let res = await knowledgeGroupApi.getKnowledgeList(params);
  tableOptions.tableData = res.data.items.map((item) => {
    item.creationTime = dayjs(item.creationTime).format("YYYY-MM-DD HH:mm:ss");
    return item;
  });
  total.value = res.data.totalCount;
};

// 新建模态框 初始值
const addVisible = ref(false);
let isAdd; //是否是新增
let title = ref("新增分组");
// -----------------------左侧新建
const newly = () => {
  isAdd = true;
  title.value = "新增分组";
  addVisible.value = true;
};
const name = ref(""); //组名称
// 新建模态框确认按钮
const click_confirm = async () => {
  // 编辑
  if (isAdd) {
    // 新增
    await knowledgeGroupApi.addGroup({ name: name.value });
  } else {
    activeItem.value.name = name.value;
    await knowledgeGroupApi.editGroup(activeItem.value);
  }
  await getGroupList();
  addVisible.value = false;
  ElMessage.success("新增成功");
};
// 编辑
const click_edit = (row) => {
  isAdd = false;
  title.value = "编辑分组";
  name.value = row.name;
  addVisible.value = true;
};
// 删除
const click_delete = ({ id }) => {
  ElMessageBox.confirm("确定删除吗?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  }).then(async () => {
    await knowledgeGroupApi.deleteGroup(id);
    await getGroupList();
    ElMessage.success("删除成功");
  });
};

// ----------------------------添加问题
const titleDrawer = ref('添加问题')
const drawerVisible = ref(false);
const addParams = ref({
  KnowledgeBaseGroupId: "",
  topic: "",
  key: "",
  answerContent: "",
});
// drawer关闭回调 清空值
const handleClosedDrawer = () => {
  addParams.value.topic = "";
  addParams.value.key = "";
  addParams.value.answerContent = "";
  addParams.value.id = "";
};

// 保存
const click_save = async () => {
  console.log(addParams.value);
  if (!addParams.value.key) return ElMessage.warning("至少添加一个关键字");
  if (addParams.value.id) {
    await knowledgeGroupApi.editKnowledge(addParams.value);
  } else {
    await knowledgeGroupApi.addKnowledge(addParams.value);
  }
  await getList();
  drawerVisible.value = false;
  ElMessage.success("保存成功");
};

// -------------------------------表格
// 编辑
const click_Row_edit = (row) => {
  Object.assign(addParams.value, row);
  drawerVisible.value = true;
  titleDrawer.value = '编辑问题'
};
// 删除
const click_Row_delete = (row) => {
  ElMessageBox.confirm("确定删除吗?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  }).then(async () => {
    await knowledgeGroupApi.deleteKnowledge(row.id);
    await getList();
    ElMessage.success("删除成功");
  });
};

// 获取分组列表
const groupList = ref([]);
const getGroupList = async () => {
  const res = await knowledgeGroupApi.getGroupList();
  groupList.value = res.data.items;
  activeItem.value = groupList.value[0];
  listParams.KnowledgeBaseGroupId = activeItem.value.id;
};
getGroupList();
</script>

<style lang="scss" scoped>
.container {
  .content-item {
    display: flex;
    min-height: 65vh;
    .content-left {
      flex-shrink: 0;
      width: 250px;
      background: #03386a;
      border-right: 1px solid #0F5BA2;
      .left-title {
        background: #134e92;
        height: 60px;
        line-height: 60px;
        color: #66baec;
        display: flex;
        justify-content: space-between;
        .left-title-text {
          margin: 0 10px;
          cursor: pointer;
        }
      }

      .left-item {
        margin: 10px auto 10px;
        width: 90%;
        color: #79cdfb;
        padding-left: 20px;
        height: 40px;
        line-height: 40px;
        border-radius: 5px;
        position: relative;
        cursor: pointer;
        .item-slh {
          position: absolute;
          right: 4px;
          top: 13px;
          transform: rotate(90deg);
        }
      }
      .left-item.active {
        background: #134e92;
      }
    }
    .content-right {
      overflow: hidden;
      flex: 1;
      .query {
        background: #03386a;
        padding-left: 20px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #66baec;
        .search-form {
          padding-top: 20px;
        }
        .query-text {
          margin-right: 20px;
        }
      }
    }
  }
}
.el-popover {
  width: 30px !important;
  padding: 5px !important;
  .content {
    div {
      text-align: center;
      transition: 0.2s;
      padding: 3px 0;
      border-radius: 3px;
      cursor: pointer;
      font-size: 14px;
      user-select: none;
      &:hover {
        background-color: #134e92;
        color: #fff;
      }
    }
  }
}

.el-drawer {
  .title {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 15px;
    .el-icon {
      cursor: pointer;
    }
  }
  .content {
    padding: 25px 20px 0;

    .answer {
      color: #707070;
      .box {
        background-color: #f5f5f5;
        padding: 15px 15px 30px 15px;
        border-radius: 5px;
        .title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            width: 63px;
            text-align: right;
          }
        }
        .answer-content {
          display: flex;
          gap: 10px;
          span {
            text-wrap: nowrap;
          }
        }
      }
      .add {
        margin-top: 10px;
        text-align: right;
      }
    }
  }
}
</style>
